import { useEffect, useState } from "react";
import { checkAccess } from "./Auth";

const AccessGate: React.FC<{ children: React.ReactNode}> = ({ children }) => {
    const [allowed, setAllowed] = useState<boolean | null>(null);

    useEffect(() => {
        checkAccess().then(setAllowed);
    }, []);

  if (allowed === null) return <div>null</div>;
  if (!allowed) return <div>Unauthorized</div>;

  return <>{children}</>;
};

export default AccessGate;